<template>
  <div :class="collapse?'zze-side fold':'zze-side'">
    <div class="side-scroll">
      <el-menu :default-active="activeIndex" :router="true" :collapse="collapse" background-color="#191a23" active-text-color="#ffd04b" text-color="#fff" @select="menuSelect" :collapse-transition="false">
        <sideMenu :menus="menusData"></sideMenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import account from "@/api/account";
import sideMenu from '@/layout/sideMenu'

export default {
  name: "sidebar",
  components: {sideMenu},
  data() {
    return {
      activeIndex: '',
      menusData: []
    }
  },
  props: {
    collapse: {
      type: Boolean,
      default: true
    },
    //linker_target: {}
  },
  created() {
    this.getMenu();
    this.activeIndex = this.$route.path;
  },
  methods: {
    getMenu() {
      const that = this;
      account.getMenuTree().then(function (res) {
        if (res) {
          that.menusData = res.data;
          //localStorage.setItem('menu',JSON.stringify(res.data));
        }
      })
    },
    /*
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },*/
    menuSelect(data) {
      this.activeIndex = data;
    },

  }
}
</script>

<style>

</style>
